import Dexie from 'dexie';

class StreaksDB extends Dexie {
  constructor() {
    super('habit-tracker-streaks');
    this.version(1).stores({
      habits: 'habitId, userId, syncStatus, deletedAt, lastUpdatedAt',
      checkins: 'id, habitId, userId, date, syncStatus, deletedAt',
      mutationQueue: '++id, status, entity, createdAt',
      meta: 'key',
    });
    // v2 — persist streak-freeze days so the freeze-aware streak math survives
    // reloads and offline sessions (id = `${habitId}#${date}`).
    this.version(2).stores({
      habits: 'habitId, userId, syncStatus, deletedAt, lastUpdatedAt',
      checkins: 'id, habitId, userId, date, syncStatus, deletedAt',
      mutationQueue: '++id, status, entity, createdAt',
      meta: 'key',
      freezes: 'id, habitId, userId, date',
    });
  }
}

export const db = new StreaksDB();

export const META_KEYS = {
  ANON_USER_ID: 'anonUserId',
  LAST_SYNC_AT: 'lastSyncAt',
  ACTIVE_USER_ID: 'activeUserId',
  ANON_BANNER_DISMISSED: 'anonBannerDismissed',
  ONBOARDED_AT: 'onboardedAt',
};
